import { Component, OnInit, ViewEncapsulation, ViewChild } from "@angular/core";
import { AppSettings } from "../../../app.settings";
import { Settings } from "../../../app.settings.model";
import { MenuService } from "../menu/menu.service";
import { AuthService } from "src/app/pages/services/auth-services.service";
import { StorageService } from "src/app/pages/services/storage.service";
import { StorageKey } from "src/app/pages/services/storage.model";
import { AdminService } from "src/app/pages/admin/admin-service";
import { Router } from "@angular/router";
@Component({
  selector: "app-sidenav",
  templateUrl: "./sidenav.component.html",
  styleUrls: ["./sidenav.component.scss"],
  encapsulation: ViewEncapsulation.None,
  providers: [MenuService],
})
export class SidenavComponent implements OnInit {
  public userImage = "../assets/img/logo2.png";
  public menuItems: any;
  public settings: Settings;
  token: string;
  user: any;
  principal: any;
  facility_code: any;
  info: string;
  user_data: any;
  menu_status: boolean;
  constructor(
    public appSettings: AppSettings,
    public menuService: MenuService,
    private service: AdminService,
    private auth: AuthService,
    private storeSvc: StorageService,
    private router: Router
  ) {
    this.settings = this.appSettings.settings;
    this.token = localStorage.getItem("currentClient");
    this.info = localStorage.getItem("userInfo");
    if (this.token) {
      this.user = this.storeSvc.read(StorageKey.CURRENT_USER);

      this.user_data = this.user.data;
      if (this.user_data) {
        this.principal = this.user_data.principal;

        // this.facility_code = this.principal.facility.facilityCode;
      }
    }
  }

  ngOnInit() {
    this.auth.hasActiveSession();
    // this.menuItems = this.menuService.getVerticalMenuItems();

    this.menu_status = false;
    // this.backendMenu()

    if (this.principal && this.principal.firstLogin) {
      this.router.navigate(["/main/change-password"]);
    } else {
      this.getMenuItems();
    }
  }

  get currentUser() {
    const user = JSON.parse(localStorage.getItem("userInfo"));
    return user && user.data && user.data.principal
      ? user.data.principal
      : null;
  }

  get roles() {
    return this.currentUser.roles.map((el) => el.displayName).join(",");
  }

  acronym(str: any) {
    // console.log("middle", str);
    const isNonEmpty = (s: string) => s != null || s != undefined || s != "";
    // console.log("isNonEmpty", isNonEmpty(str));
    return !isNonEmpty(str) ? str.match(/\b\w/g).join("") : null;
  }

  get fullName() {
    return this.concatenate([
      this.currentUser.firstName,
      " ",
      this.acronym(this.currentUser.middleName),
      ". ",
      this.currentUser.lastName,
    ]);
  }

  titleCase(str) {
    return str
      ? str
          .toLowerCase()
          .split(" ")
          .map(function (word) {
            return word.charAt(0).toUpperCase() + word.slice(1);
          })
          .join(" ")
      : null;
  }

  concatenate(str: any = Array) {
    return "".concat(str.join(" "));
  }

  getMenuItems() {
    this.menu_status = true;
    this.menuItems =
      this.currentUser && this.currentUser.roles
        ? this.currentUser.roles
            .flatMap((menu) => menu.menuList)

            .filter(
              (menu, index, menuItems) =>
                menuItems.findIndex((item) => item.id === menu.id) === index // <=== removes duplicates menus for user with multiple roles
            )
            .sort((a, b) => {
              return a.sorting > b.sorting ? 1 : -1;
            })
        : [];
  }

  backendMenu() {
    this.service.menus().subscribe((response) => {
      if (response) {
        this.menu_status = true;
        this.menuItems = response.data.sort((a, b) => {
          return a.sorting > b.sorting ? 1 : -1;
        });

        //
      }
    });
  }
  public closeSubMenus() {
    let menu = document.getElementById("vertical-menu");
    if (menu) {
      for (let i = 0; i < menu.children[0].children.length; i++) {
        let child = menu.children[0].children[i];
        if (child) {
          if (child.children[0].classList.contains("expanded")) {
            child.children[0].classList.remove("expanded");
            child.children[1].classList.remove("show");
          }
        }
      }
    }
  }

  logout() {
    this.auth.logout("isDirectCall"); // do not remove this
  }
}
